import { configureStore, combineReducers } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";
import loginSlice from "./reducers/loginSlice";
import stylingSlice from "./reducers/stylingSlice";
import masterCommonSlice from "./reducers/masterCommonData";
import elasticSearchSlice from "./reducers/elasticSearchSlice";

const persistConfig = {
  key: "root",
  version: 1,
  storage,
  blacklist: ["register"],
};

const reducer = combineReducers({
  login: loginSlice,
  styling: stylingSlice,
  commonData: masterCommonSlice,
  ElasticSearch: elasticSearchSlice
});

const persistedReducer = persistReducer(persistConfig, reducer);

export default configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
